export const IS_DEV = process.env.NODE_ENV === 'development';
export const IS_PROD = process.env.NODE_ENV === 'production';

export const WEB3_ETHERSCAN_API_KEY = process.env.WEB3_ETHERSCAN_API_KEY || '';
export const WEB3_DEFI_STU_SMART_CONTRACT_ADDRESS = process.env.WEB3_DEFI_STU_SMART_CONTRACT_ADDRESS || '';
export const WEB3_DEFI_SERVER_WALLET_PUBLIC_ADDRESS = process.env.WEB3_DEFI_SERVER_WALLET_PUBLIC_ADDRESS || '';

export const FACEBOOK_KEY = process.env.FACEBOOK_KEY || '';

export const SENTRY_DSN = process.env.SENTRY_DSN || '';
export const NPM_PACKAGE_VERSION = process.env.NPM_PACKAGE_VERSION || '0.0.0';

export const HYPERDX_APIKEY = process.env.HYPERDX_APIKEY || '';
